// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Zp5fR","fullView":"styles_fullView__2za5s"};